import { DateTime } from "luxon"

export const getFormattedDatetime = (date: string) => {
    return `${DateTime.fromISO(date).toFormat("dd/MM/yyyy - HH")}h${DateTime.fromISO(date).toFormat("mm")}`
}